// extracted by mini-css-extract-plugin
export default {"MainDiv":"CancelledOrder_MainDiv__B2eeh","TableDiv":"CancelledOrder_TableDiv__YRNTT","TableButton":"CancelledOrder_TableButton__SSomH"};